export default function has(prop, obj) {
	return Object.prototype.hasOwnProperty.call(obj, prop)
}
